import { MONTHS } from '../constants/date';

export const toTimeAndDate = (ms) => {
  const iso = new Date(ms).toISOString();
  const dateObj = new Date(iso);

  const time = iso.match(/\d\d:\d\d/);
  const hour = dateObj.getUTCHours();
  const amOrPm = hour >= 12 ? 'pm' : 'am';

  const day = dateObj.getDate();
  const month = MONTHS[dateObj.getMonth()];
  const year = dateObj.getUTCFullYear();

  return `${time} ${amOrPm} • ${day} ${month} ${year}`;
};
